__turbopack_context__.v({
  "sectionTitle": "SectionTitle-module__6gUcra__sectionTitle",
});
